Object.defineProperty(exports, "__esModule", {
  value: !0
});
var SIZE_XS = 320,
  SIZE_SM = 576,
  SIZE_MD = 768,
  SIZE_LG = 992,
  SIZE_XL = 1200,
  SIZES = {
    SIZE_XS: SIZE_XS,
    SIZE_SM: SIZE_SM,
    SIZE_MD: SIZE_MD,
    SIZE_LG: SIZE_LG,
    SIZE_XL: SIZE_XL
  },
  device = {
    mobile: "(min-width: " + SIZE_XS + "px)",
    mobileL: "(min-width: " + SIZE_SM + "px)",
    tablet: "(min-width: " + SIZE_MD + "px)",
    tabletL: "(min-width: " + SIZE_LG + "px)",
    desktop: "(min-width: " + SIZE_XL + "px)"
  },
  deviceDown = {
    mobile: "(max-width: " + (SIZE_SM - 1) + "px)",
    mobileL: "(max-width: " + (SIZE_MD - 1) + "px)",
    tablet: "(max-width: " + (SIZE_LG - 1) + "px)",
    tabletL: "(max-width: " + (SIZE_XL - 1) + "px)"
  },
  deviceOnly = {
    mobile: "(max-width: " + SIZE_SM + "px)",
    mobileL: "(min-width: " + SIZE_SM + "px) and (max-width: " + (SIZE_MD - 1) + "px)",
    tablet: "(min-width: " + SIZE_MD + "px) and (max-width: " + (SIZE_LG - 1) + "px)",
    tabletL: "(min-width: " + SIZE_LG + "px) and (max-width: " + (SIZE_XL - 1) + "px)",
    desktop: "(min-width: " + SIZE_XL + "px)"
  },
  breakpoints = {
    device: device,
    deviceDown: deviceDown,
    deviceOnly: deviceOnly
  },
  colors = {
    AeroBlue: "#c6eada",
    AzureX: "#e6f7fb",
    AzureXDark: "#0a1f26",
    BabyPink: "#f8c9c5",
    Black: "#000000",
    BlackTransparent: "rgba(0,0,0,0.7)",
    BlackTransparentLight: "rgba(0,0,0,0.2)",
    BlackTransparentMedium: "rgba(0,0,0,0.35)",
    BlizzardBlue: "#b3e8f4",
    BlueCloudy: "#a7bdcc",
    BlueCloudyTransparent: "rgba(167,189,204,0.5)",
    BlueDark: "#2c3b45",
    BlueDarkGradient: "linear-gradient(-225deg, rgb(44, 59, 69) 0%, rgb(78, 98, 110) 100%)",
    BlueDawn: "#007f9e",
    BlueFog: "#CEDAE1",
    BlueHeaven: "#64dfff",
    BlueLight: "#E4EBEF",
    BlueLightGradient: "linear-gradient(-225deg, rgb(235, 249, 252) 0%, rgb(191, 240, 247) 100%)",
    BlueMoon: "#3c5463",
    BlueNight: "#1D6478",
    BlueSky: "#00b3db",
    BlueSkyVivid: "#33c2e2",
    BlueSmoke: "#F1F5F7",
    Bittersweet: "#ed7064",
    Bunker: "#171E24",
    DeepChampagne: "#fbd38d",
    GreenDark: "#19a568",
    GreenFlash: "#44DB5E",
    GreenGarden: "#029231",
    GreenLight: "#52cb95",
    GreenMedium: "#1AAF5D",
    GreenOcean: "#67c89d",
    GreenSeafoam: "#41ba84",
    Grey: "#e6e8e9",
    GreyBackground: "#ebf0f2",
    GreyBlue: "#5A7A8E",
    GreyBright: "#f7f7f7",
    GreyDark: "#5e6467",
    GreyLight: "#d8d8d8",
    GreyMedium: "#b7b7b7",
    GreyWarm: "#959da2",
    GreyWhite: "#efefef",
    HoneyDew: "#d9f1e6",
    HoneyDewDark: "#153127",
    LavenderBlush: "#fdedec",
    LavenderBlushDark: "#201516",
    LightCyan: "#ccf0f8",
    LightCyanDark: "#07313A",
    MagicMint: "#b3e3ce",
    Melon: "#f6b7b1",
    MintCream: "#ecf8f3",
    MintCreamDark: "#10201D",
    MistyRose: "#fadbd8",
    MistyRoseDark: "#361B1A",
    NonPhotoBlue: "#99e1f1",
    OldLace: "#fef6e8",
    OldLaceDark: "#221E13",
    Orange: "#f7a71a",
    OrangeDark: "#ff860f",
    PapayaWhip: "#fdedd1",
    PapayaWhipDark: "#392D13",
    Peach: "#fde5da",
    Purple: "#b90059",
    Sunary: "#f9c15f",
    Tomato: "#e84c3d",
    TomatoDark: "#ca4036",
    TomatoLight: "#eb8b84",
    TomatoFlash: "#CB1212",
    Transparent: "transparent",
    VisaGold: "#a18950",
    VisaPlatinum: "#86898b",
    White: "#ffffff",
    WhiteTransparent: "rgba(255,255,255,0.3)",
    YellowVanilla: "#fbf4d3",
    Grey10Ghost: "#F7F9FA",
    Grey20Smoke: "#F2F5F7",
    Grey30Mist: "#E6EDF0",
    Grey40Haze: "#DAE3E8",
    Grey50Fog: "#CEDAE0",
    Grey60Smog: "#BAC8CF",
    Grey70Cloudy: "#A9BAC4",
    Grey80Concrete: "#A0B1BA",
    Grey90Silver: "#94A7B0",
    Grey100Steel: "#889CA6",
    Grey200Slate: "#7C919C",
    Grey300Lead: "#7C919C",
    Grey400Iron: "#677C87",
    Grey500Titanium: "#5C727D",
    Grey600Graphite: "#536673",
    Grey700Obsidian: "#495C69",
    Grey800Darkblue: "#2C3B45",
    Grey850Shadow: "#24323C",
    Grey900Night: "#1E2A33",
    Grey950Pitchdark: "#172026",
    Grey1000Black: "#000000",
    Red100: "#FAE9E7",
    Red200: "#F6D2CE",
    Red300: "#EDA59D",
    Red400: "#E3786D",
    Red500: "#DA4B3C",
    Red600: "#D11E0B",
    Red700: "#A71809",
    Red800: "#7D1207",
    Orange100: "#FEF6E8",
    Orange200: "#FDEDD1",
    Orange300: "#FCDCA3",
    Orange400: "#FACA76",
    Orange500: "#F9B948",
    Orange600: "#F7A71A",
    Orange700: "#DE9617",
    Orange800: "#C68615",
    Orange900: "#8A6628",
    Green100: "#E6F3EE",
    Green200: "#CDE8DE",
    Green300: "#9AD0BD",
    Green400: "#35A17A",
    Green500: "#1C9166",
    Green600: "#038153",
    Green700: "#026E47",
    Green800: "#025335",
    Blue100: "#E6F7FB",
    Blue200: "#CCF0F8",
    Blue300: "#B3E8F4",
    Blue400: "#99E1F1",
    Blue500: "#33C2E2",
    Blue600Sky: "#00B3DB",
    Blue700Dawn: "#007F9E",
    Blue800: "#006480"
  },
  isValid = function (e) {
    if (void 0 === colors[e]) throw new Error("Unknown color " + e);
    return !0;
  },
  hexToTransparentRGBA = function (e, n) {
    isValid(e);
    var e = colors[e];
    return 7 < e.length || "#" !== e.substr(0, 1) ? null : (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), "rgba(" + parseInt(e[1], 16) + ", " + parseInt(e[2], 16) + ", " + parseInt(e[3], 16) + ", " + (n || 0) + ")");
  },
  colors$1 = {
    hexToTransparentRGBA: hexToTransparentRGBA,
    list: colors
  },
  countries = {
    af: {
      phone: "+93",
      isSepa: !1
    },
    ax: {
      phone: "+358",
      isSepa: !1
    },
    al: {
      phone: "+355",
      isSepa: !1
    },
    dz: {
      phone: "+213",
      isSepa: !1
    },
    as: {
      phone: "+1684",
      isSepa: !1
    },
    ad: {
      phone: "+376",
      isSepa: !0
    },
    ao: {
      phone: "+244",
      isSepa: !1
    },
    ai: {
      phone: "+1264",
      isSepa: !1
    },
    aq: {
      phone: "+672",
      isSepa: !1
    },
    ag: {
      phone: "+1268",
      isSepa: !1
    },
    ar: {
      phone: "+54",
      isSepa: !1
    },
    am: {
      phone: "+374",
      isSepa: !1
    },
    aw: {
      phone: "+297",
      isSepa: !1
    },
    au: {
      phone: "+61",
      isSepa: !1
    },
    at: {
      phone: "+43",
      isSepa: !0
    },
    az: {
      phone: "+994",
      isSepa: !1
    },
    bs: {
      phone: "+1242",
      isSepa: !1
    },
    bh: {
      phone: "+973",
      isSepa: !1
    },
    bd: {
      phone: "+880",
      isSepa: !1
    },
    bb: {
      phone: "+1246",
      isSepa: !1
    },
    by: {
      phone: "+375",
      isSepa: !1
    },
    be: {
      phone: "+32",
      isSepa: !0
    },
    bz: {
      phone: "+501",
      isSepa: !1
    },
    bj: {
      phone: "+229",
      isSepa: !1
    },
    bm: {
      phone: "+1441",
      isSepa: !1
    },
    bt: {
      phone: "+975",
      isSepa: !1
    },
    bo: {
      phone: "+591",
      isSepa: !1
    },
    ba: {
      phone: "+387",
      isSepa: !1
    },
    bw: {
      phone: "+267",
      isSepa: !1
    },
    bv: {
      phone: "+47",
      isSepa: !1
    },
    br: {
      phone: "+55",
      isSepa: !1
    },
    io: {
      phone: "+246",
      isSepa: !1
    },
    bn: {
      phone: "+673",
      isSepa: !1
    },
    bg: {
      phone: "+359",
      isSepa: !0
    },
    bf: {
      phone: "+226",
      isSepa: !1
    },
    bi: {
      phone: "+257",
      isSepa: !1
    },
    kh: {
      phone: "+855",
      isSepa: !1
    },
    cm: {
      phone: "+237",
      isSepa: !1
    },
    ca: {
      phone: "+1",
      isSepa: !1
    },
    cv: {
      phone: "+238",
      isSepa: !1
    },
    ky: {
      phone: "+345",
      isSepa: !1
    },
    cf: {
      phone: "+236",
      isSepa: !1
    },
    td: {
      phone: "+235",
      isSepa: !1
    },
    cl: {
      phone: "+56",
      isSepa: !1
    },
    cn: {
      phone: "+86",
      isSepa: !1
    },
    cx: {
      phone: "+61",
      isSepa: !1
    },
    cc: {
      phone: "+61",
      isSepa: !1
    },
    co: {
      phone: "+57",
      isSepa: !1
    },
    km: {
      phone: "+269",
      isSepa: !1
    },
    cg: {
      phone: "+242",
      isSepa: !1
    },
    cd: {
      phone: "+243",
      isSepa: !1
    },
    ck: {
      phone: "+682",
      isSepa: !1
    },
    cr: {
      phone: "+506",
      isSepa: !1
    },
    ci: {
      phone: "+225",
      isSepa: !1
    },
    hr: {
      phone: "+385",
      isSepa: !0
    },
    cu: {
      phone: "+53",
      isSepa: !1
    },
    cy: {
      phone: "+357",
      isSepa: !0
    },
    cz: {
      phone: "+420",
      isSepa: !0
    },
    dk: {
      phone: "+45",
      isSepa: !0
    },
    dj: {
      phone: "+253",
      isSepa: !1
    },
    dm: {
      phone: "+1767",
      isSepa: !1
    },
    do: {
      phone: "+1849",
      isSepa: !1
    },
    ec: {
      phone: "+593",
      isSepa: !1
    },
    eg: {
      phone: "+20",
      isSepa: !1
    },
    sv: {
      phone: "+503",
      isSepa: !1
    },
    gq: {
      phone: "+240",
      isSepa: !1
    },
    er: {
      phone: "+291",
      isSepa: !1
    },
    ee: {
      phone: "+372",
      isSepa: !0
    },
    et: {
      phone: "+251",
      isSepa: !1
    },
    fk: {
      phone: "+500",
      isSepa: !1
    },
    fo: {
      phone: "+298",
      isSepa: !1
    },
    fj: {
      phone: "+679",
      isSepa: !1
    },
    fi: {
      phone: "+358",
      isSepa: !0
    },
    fr: {
      phone: "+33",
      isSepa: !0
    },
    gf: {
      phone: "+594",
      isSepa: !1
    },
    pf: {
      phone: "+689",
      isSepa: !1
    },
    tf: {
      phone: "+262",
      isSepa: !1
    },
    ga: {
      phone: "+241",
      isSepa: !1
    },
    gm: {
      phone: "+220",
      isSepa: !1
    },
    ge: {
      phone: "+995",
      isSepa: !1
    },
    de: {
      phone: "+49",
      isSepa: !0
    },
    gh: {
      phone: "+233",
      isSepa: !1
    },
    gi: {
      phone: "+350",
      isSepa: !0
    },
    gr: {
      phone: "+30",
      isSepa: !0
    },
    gl: {
      phone: "+299",
      isSepa: !1
    },
    gd: {
      phone: "+1473",
      isSepa: !1
    },
    gp: {
      phone: "+590",
      isSepa: !1
    },
    gu: {
      phone: "+1671",
      isSepa: !1
    },
    gt: {
      phone: "+502",
      isSepa: !1
    },
    gg: {
      phone: "+44",
      isSepa: !1
    },
    gn: {
      phone: "+224",
      isSepa: !1
    },
    gw: {
      phone: "+245",
      isSepa: !1
    },
    gy: {
      phone: "+592",
      isSepa: !1
    },
    ht: {
      phone: "+509",
      isSepa: !1
    },
    hm: {
      phone: "+0",
      isSepa: !1
    },
    hn: {
      phone: "+504",
      isSepa: !1
    },
    hk: {
      phone: "+852",
      isSepa: !1
    },
    hu: {
      phone: "+36",
      isSepa: !0
    },
    is: {
      phone: "+354",
      isSepa: !0
    },
    in: {
      phone: "+91",
      isSepa: !1
    },
    id: {
      phone: "+62",
      isSepa: !1
    },
    ir: {
      phone: "+98",
      isSepa: !1
    },
    iq: {
      phone: "+964",
      isSepa: !1
    },
    ie: {
      phone: "+353",
      isSepa: !0
    },
    im: {
      phone: "+44",
      isSepa: !1
    },
    il: {
      phone: "+972",
      isSepa: !1
    },
    it: {
      phone: "+39",
      isSepa: !0
    },
    jm: {
      phone: "+1876",
      isSepa: !1
    },
    jp: {
      phone: "+81",
      isSepa: !1
    },
    je: {
      phone: "+44",
      isSepa: !1
    },
    jo: {
      phone: "+962",
      isSepa: !1
    },
    kz: {
      phone: "+7",
      isSepa: !1
    },
    ke: {
      phone: "+254",
      isSepa: !1
    },
    ki: {
      phone: "+686",
      isSepa: !1
    },
    kp: {
      phone: "+850",
      isSepa: !1
    },
    kr: {
      phone: "+82",
      isSepa: !1
    },
    xk: {
      phone: "+383",
      isSepa: !1
    },
    kw: {
      phone: "+965",
      isSepa: !1
    },
    kg: {
      phone: "+996",
      isSepa: !1
    },
    la: {
      phone: "+856",
      isSepa: !1
    },
    lv: {
      phone: "+371",
      isSepa: !0
    },
    lb: {
      phone: "+961",
      isSepa: !1
    },
    ls: {
      phone: "+266",
      isSepa: !1
    },
    lr: {
      phone: "+231",
      isSepa: !1
    },
    ly: {
      phone: "+218",
      isSepa: !1
    },
    li: {
      phone: "+423",
      isSepa: !0
    },
    lt: {
      phone: "+370",
      isSepa: !0
    },
    lu: {
      phone: "+352",
      isSepa: !0
    },
    mo: {
      phone: "+853",
      isSepa: !1
    },
    mk: {
      phone: "+389",
      isSepa: !1
    },
    mg: {
      phone: "+261",
      isSepa: !1
    },
    mw: {
      phone: "+265",
      isSepa: !1
    },
    my: {
      phone: "+60",
      isSepa: !1
    },
    mv: {
      phone: "+960",
      isSepa: !1
    },
    ml: {
      phone: "+223",
      isSepa: !1
    },
    mt: {
      phone: "+356",
      isSepa: !0
    },
    mh: {
      phone: "+692",
      isSepa: !1
    },
    mq: {
      phone: "+596",
      isSepa: !1
    },
    mr: {
      phone: "+222",
      isSepa: !1
    },
    mu: {
      phone: "+230",
      isSepa: !1
    },
    yt: {
      phone: "+262",
      isSepa: !1
    },
    mx: {
      phone: "+52",
      isSepa: !1
    },
    fm: {
      phone: "+691",
      isSepa: !1
    },
    md: {
      phone: "+373",
      isSepa: !1
    },
    mc: {
      phone: "+377",
      isSepa: !0
    },
    mn: {
      phone: "+976",
      isSepa: !1
    },
    me: {
      phone: "+382",
      isSepa: !1
    },
    ms: {
      phone: "+1664",
      isSepa: !1
    },
    ma: {
      phone: "+212",
      isSepa: !1
    },
    mz: {
      phone: "+258",
      isSepa: !1
    },
    mm: {
      phone: "+95",
      isSepa: !1
    },
    na: {
      phone: "+264",
      isSepa: !1
    },
    nr: {
      phone: "+674",
      isSepa: !1
    },
    np: {
      phone: "+977",
      isSepa: !1
    },
    nl: {
      phone: "+31",
      isSepa: !0
    },
    nc: {
      phone: "+687",
      isSepa: !1
    },
    nz: {
      phone: "+64",
      isSepa: !1
    },
    ni: {
      phone: "+505",
      isSepa: !1
    },
    ne: {
      phone: "+227",
      isSepa: !1
    },
    ng: {
      phone: "+234",
      isSepa: !1
    },
    nu: {
      phone: "+683",
      isSepa: !1
    },
    nf: {
      phone: "+672",
      isSepa: !1
    },
    mp: {
      phone: "+1670",
      isSepa: !1
    },
    no: {
      phone: "+47",
      isSepa: !0
    },
    om: {
      phone: "+968",
      isSepa: !1
    },
    pk: {
      phone: "+92",
      isSepa: !1
    },
    pw: {
      phone: "+680",
      isSepa: !1
    },
    ps: {
      phone: "+970",
      isSepa: !1
    },
    pa: {
      phone: "+507",
      isSepa: !1
    },
    pg: {
      phone: "+675",
      isSepa: !1
    },
    py: {
      phone: "+595",
      isSepa: !1
    },
    pe: {
      phone: "+51",
      isSepa: !1
    },
    ph: {
      phone: "+63",
      isSepa: !1
    },
    pn: {
      phone: "+64",
      isSepa: !1
    },
    pl: {
      phone: "+48",
      isSepa: !0
    },
    pt: {
      phone: "+351",
      isSepa: !0
    },
    pr: {
      phone: "+1939",
      isSepa: !1
    },
    qa: {
      phone: "+974",
      isSepa: !1
    },
    ro: {
      phone: "+40",
      isSepa: !0
    },
    ru: {
      phone: "+7",
      isSepa: !1
    },
    rw: {
      phone: "+250",
      isSepa: !1
    },
    re: {
      phone: "+262",
      isSepa: !1
    },
    bl: {
      phone: "+590",
      isSepa: !1
    },
    sh: {
      phone: "+290",
      isSepa: !1
    },
    kn: {
      phone: "+1869",
      isSepa: !1
    },
    lc: {
      phone: "+1758",
      isSepa: !1
    },
    mf: {
      phone: "+590",
      isSepa: !1
    },
    pm: {
      phone: "+508",
      isSepa: !1
    },
    vc: {
      phone: "+1784",
      isSepa: !1
    },
    ws: {
      phone: "+685",
      isSepa: !1
    },
    sm: {
      phone: "+378",
      isSepa: !0
    },
    st: {
      phone: "+239",
      isSepa: !1
    },
    sa: {
      phone: "+966",
      isSepa: !1
    },
    sn: {
      phone: "+221",
      isSepa: !1
    },
    rs: {
      phone: "+381",
      isSepa: !1
    },
    sc: {
      phone: "+248",
      isSepa: !1
    },
    sl: {
      phone: "+232",
      isSepa: !1
    },
    sg: {
      phone: "+65",
      isSepa: !1
    },
    sk: {
      phone: "+421",
      isSepa: !0
    },
    si: {
      phone: "+386",
      isSepa: !0
    },
    sb: {
      phone: "+677",
      isSepa: !1
    },
    so: {
      phone: "+252",
      isSepa: !1
    },
    za: {
      phone: "+27",
      isSepa: !1
    },
    ss: {
      phone: "+211",
      isSepa: !1
    },
    gs: {
      phone: "+500",
      isSepa: !1
    },
    es: {
      phone: "+34",
      isSepa: !0
    },
    lk: {
      phone: "+94",
      isSepa: !1
    },
    sd: {
      phone: "+249",
      isSepa: !1
    },
    sr: {
      phone: "+597",
      isSepa: !1
    },
    sj: {
      phone: "+47",
      isSepa: !1
    },
    sz: {
      phone: "+268",
      isSepa: !1
    },
    se: {
      phone: "+46",
      isSepa: !0
    },
    ch: {
      phone: "+41",
      isSepa: !0
    },
    sy: {
      phone: "+963",
      isSepa: !1
    },
    tw: {
      phone: "+886",
      isSepa: !1
    },
    tj: {
      phone: "+992",
      isSepa: !1
    },
    tz: {
      phone: "+255",
      isSepa: !1
    },
    th: {
      phone: "+66",
      isSepa: !1
    },
    tl: {
      phone: "+670",
      isSepa: !1
    },
    tg: {
      phone: "+228",
      isSepa: !1
    },
    tk: {
      phone: "+690",
      isSepa: !1
    },
    to: {
      phone: "+676",
      isSepa: !1
    },
    tt: {
      phone: "+1868",
      isSepa: !1
    },
    tn: {
      phone: "+216",
      isSepa: !1
    },
    tr: {
      phone: "+90",
      isSepa: !1
    },
    tm: {
      phone: "+993",
      isSepa: !1
    },
    tc: {
      phone: "+1649",
      isSepa: !1
    },
    tv: {
      phone: "+688",
      isSepa: !1
    },
    ug: {
      phone: "+256",
      isSepa: !1
    },
    ua: {
      phone: "+380",
      isSepa: !1
    },
    ae: {
      phone: "+971",
      isSepa: !1
    },
    gb: {
      phone: "+44",
      isSepa: !0
    },
    us: {
      phone: "+1",
      isSepa: !1
    },
    uy: {
      phone: "+598",
      isSepa: !1
    },
    uz: {
      phone: "+998",
      isSepa: !1
    },
    va: {
      phone: "+379",
      isSepa: !0
    },
    vu: {
      phone: "+678",
      isSepa: !1
    },
    ve: {
      phone: "+58",
      isSepa: !1
    },
    vn: {
      phone: "+84",
      isSepa: !1
    },
    vg: {
      phone: "+1284",
      isSepa: !1
    },
    vi: {
      phone: "+1340",
      isSepa: !1
    },
    wf: {
      phone: "+681",
      isSepa: !1
    },
    ye: {
      phone: "+967",
      isSepa: !1
    },
    zm: {
      phone: "+260",
      isSepa: !1
    },
    zw: {
      phone: "+263",
      isSepa: !1
    }
  },
  isoList = Object.keys(countries),
  countryList = {
    isoList: isoList,
    list: countries
  },
  currencies = {
    EUR: {
      value: "EUR",
      isDefault: !0,
      exceptions: [],
      moneyWire: !0,
      conversion: !0
    },
    AUD: {
      value: "AUD",
      isDefault: !1,
      exceptions: ["AU"],
      moneyWire: !0,
      conversions: !0
    },
    CAD: {
      value: "CAD",
      isDefault: !1,
      exceptions: ["CA"],
      moneyWire: !0,
      conversion: !0
    },
    CHF: {
      value: "CHF",
      isDefault: !1,
      exceptions: ["CH", "LI"],
      moneyWire: !0,
      conversion: !0
    },
    DKK: {
      value: "DKK",
      isDefault: !1,
      exceptions: ["DK"],
      moneyWire: !0,
      conversion: !0
    },
    GBP: {
      value: "GBP",
      isDefault: !1,
      exceptions: ["GB"],
      moneyWire: !0,
      conversion: !0
    },
    HUF: {
      value: "HUF",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    },
    JPY: {
      value: "JPY",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    },
    NOK: {
      value: "NOK",
      isDefault: !1,
      exceptions: ["NO"],
      moneyWire: !0,
      conversion: !0
    },
    NZD: {
      value: "NZD",
      isDefault: !1,
      exceptions: ["NZ"],
      moneyWire: !0,
      conversion: !0
    },
    SEK: {
      value: "SEK",
      isDefault: !1,
      exceptions: ["SE"],
      moneyWire: !0,
      conversion: !0
    },
    USD: {
      value: "USD",
      isDefault: !0,
      exceptions: [],
      moneyWire: !0,
      conversion: !0
    },
    ZAR: {
      value: "ZAR",
      isDefault: !1,
      exceptions: ["ZA", "NA"],
      moneyWire: !0,
      conversion: !0
    },
    TRY: {
      value: "TRY",
      isDefault: !1,
      exceptions: [],
      moneyWire: !1,
      conversion: !0
    }
  },
  currencies$1 = {
    list: currencies
  },
  fontList = {
    bold: '"OpenSans Bold",sans-serif',
    extraBold: '"OpenSans ExtraBold",sans-serif',
    light: '"OpenSans Light",sans-serif',
    regular: '"OpenSans",sans-serif',
    semiBold: '"OpenSans SemiBold",sans-serif',
    boldItalic: '"OpenSans BoldItalic",sans-serif',
    regularItalic: '"OpenSans Italic",sans-serif',
    semiBoldItalic: '"OpenSans SemiBoldItalic",sans-serif',
    avertaBold: '"Averta Bold",sans-serif',
    avertaExtraBold: '"Averta ExtraBold",sans-serif',
    avertaLight: '"Averta Light",sans-serif',
    avertaRegular: '"Averta",sans-serif',
    avertaSemiBold: '"Averta SemiBold",sans-serif',
    avertaBoldItalic: '"Averta BoldItalic",sans-serif',
    avertaRegularItalic: '"Averta Italic",sans-serif',
    avertaSemiBoldItalic: '"Averta SemiBoldItalic",sans-serif'
  },
  getFont = function (e, n) {
    return (e.fonts && e.fonts[n] ? e.fonts : fontList)[n];
  },
  fonts = {
    getFont: getFont
  },
  fontSizes = {
    mobile: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "2.4rem",
      xg: "3.0rem"
    },
    mobileTitle: {
      xs: "1.8rem",
      sm: "2.3rem",
      md: "3.0rem",
      df: "3.3rem",
      lg: "4.0rem",
      xl: "4.8rem",
      gt: "5.2rem",
      xg: "5.6rem"
    },
    tablet: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "2.4rem",
      xg: "3.0rem"
    },
    tabletTitle: {
      xs: "1.8rem",
      sm: "2.3rem",
      md: "3.0rem",
      df: "3.3rem",
      lg: "4.0rem",
      xl: "4.8rem",
      gt: "5.2rem",
      xg: "5.6rem"
    },
    desktop: {
      xs: "1.0rem",
      sm: "1.2rem",
      md: "1.4rem",
      df: "1.6rem",
      lg: "1.8rem",
      xl: "2.0rem",
      gt: "3.0rem",
      xg: "5.0rem"
    },
    desktopTitle: {
      xs: "2.0rem",
      sm: "2.6rem",
      md: "3.0rem",
      df: "3.6rem",
      lg: "4.2rem",
      xl: "5.0rem",
      gt: "6.0rem",
      xg: "7.0rem"
    }
  },
  spacings = {
    zero: "0",
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "3rem",
    xl: "4rem",
    gt: "5rem",
    xg: "6rem",
    auto: "auto"
  },
  config = {
    breakpoints: breakpoints,
    colors: colors$1,
    countries: countryList,
    currencies: currencies$1,
    fonts: fonts,
    fontSizes: fontSizes,
    spacings: spacings
  },
  commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function createCommonjsModule(e, n) {
  return e(n = {
    exports: {}
  }, n.exports), n.exports;
}
var iban = createCommonjsModule(function (e, n) {
    var r, t;
    r = commonjsGlobal, t = function (e) {
      Array.prototype.map || (Array.prototype.map = function (e) {
        if (null == this) throw new TypeError();
        var n = Object(this),
          r = n.length >>> 0;
        if ("function" != typeof e) throw new TypeError();
        for (var t = new Array(r), a = 2 <= arguments.length ? arguments[1] : void 0, s = 0; s < r; s++) s in n && (t[s] = e.call(a, n[s], s, n));
        return t;
      });
      var r = "A".charCodeAt(0),
        t = "Z".charCodeAt(0);
      function a(e) {
        return (e = (e = e.toUpperCase()).substr(4) + e.substr(0, 4)).split("").map(function (e) {
          var n = e.charCodeAt(0);
          return r <= n && n <= t ? n - r + 10 : e;
        }).join("");
      }
      function s(e) {
        for (var n, r = e; 2 < r.length;) n = r.slice(0, 9), r = parseInt(n, 10) % 97 + r.slice(n.length);
        return parseInt(r, 10) % 97;
      }
      function i(e) {
        return e.replace(d, "").toUpperCase();
      }
      function n(e, n, r, t) {
        this.countryCode = e, this.length = n, this.structure = r, this.example = t;
      }
      n.prototype._regex = function () {
        return this._cachedRegex || (this._cachedRegex = (e = (e = this.structure).match(/(.{3})/g).map(function (e) {
          var n,
            r = e.slice(0, 1),
            e = parseInt(e.slice(1), 10);
          switch (r) {
            case "A":
              n = "0-9A-Za-z";
              break;
            case "B":
              n = "0-9A-Z";
              break;
            case "C":
              n = "A-Za-z";
              break;
            case "F":
              n = "0-9";
              break;
            case "L":
              n = "a-z";
              break;
            case "U":
              n = "A-Z";
              break;
            case "W":
              n = "0-9a-z";
          }
          return "([" + n + "]{" + e + "})";
        }), new RegExp("^" + e.join("") + "$")));
        var e;
      }, n.prototype.isValid = function (e) {
        return this.length == e.length && this.countryCode === e.slice(0, 2) && this._regex().test(e.slice(4)) && 1 == s(a(e));
      }, n.prototype.toBBAN = function (e, n) {
        return this._regex().exec(e.slice(4)).slice(1).join(n);
      }, n.prototype.fromBBAN = function (e) {
        var n;
        if (this.isValidBBAN(e)) return n = ("0" + (98 - s(a(this.countryCode + "00" + e)))).slice(-2), this.countryCode + n + e;
        throw new Error("Invalid BBAN");
      }, n.prototype.isValidBBAN = function (e) {
        return this.length - 4 == e.length && this._regex().test(e);
      };
      var o = {};
      function u(e) {
        o[e.countryCode] = e;
      }
      u(new n("AD", 24, "F04F04A12", "AD1200012030200359100100")), u(new n("AE", 23, "F03F16", "AE070331234567890123456")), u(new n("AL", 28, "F08A16", "AL47212110090000000235698741")), u(new n("AT", 20, "F05F11", "AT611904300234573201")), u(new n("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944")), u(new n("BA", 20, "F03F03F08F02", "BA391290079401028494")), u(new n("BE", 16, "F03F07F02", "BE68539007547034")), u(new n("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678")), u(new n("BH", 22, "U04A14", "BH67BMAG00001299123456")), u(new n("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1")), u(new n("BY", 28, "A04F04A16", "BY13NBRB3600900000002Z00AB00")), u(new n("CH", 21, "F05A12", "CH9300762011623852957")), u(new n("CR", 22, "F04F14", "CR72012300000171549015")), u(new n("CY", 28, "F03F05A16", "CY17002001280000001200527600")), u(new n("CZ", 24, "F04F06F10", "CZ6508000000192000145399")), u(new n("DE", 22, "F08F10", "DE89370400440532013000")), u(new n("DK", 18, "F04F09F01", "DK5000400440116243")), u(new n("DO", 28, "U04F20", "DO28BAGR00000001212453611324")), u(new n("EE", 20, "F02F02F11F01", "EE382200221020145685")), u(new n("EG", 29, "F04F04F17", "EG800002000156789012345180002")), u(new n("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332")), u(new n("FI", 18, "F06F07F01", "FI2112345600000785")), u(new n("FO", 18, "F04F09F01", "FO6264600001631634")), u(new n("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606")), u(new n("GB", 22, "U04F06F08", "GB29NWBK60161331926819")), u(new n("GE", 22, "U02F16", "GE29NB0000000101904917")), u(new n("GI", 23, "U04A15", "GI75NWBK000000007099453")), u(new n("GL", 18, "F04F09F01", "GL8964710001000206")), u(new n("GR", 27, "F03F04A16", "GR1601101250000000012300695")), u(new n("GT", 28, "A04A20", "GT82TRAJ01020000001210029690")), u(new n("HR", 21, "F07F10", "HR1210010051863000160")), u(new n("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000")), u(new n("IE", 22, "U04F06F08", "IE29AIBK93115212345678")), u(new n("IL", 23, "F03F03F13", "IL620108000000099999999")), u(new n("IS", 26, "F04F02F06F10", "IS140159260076545510730339")), u(new n("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456")), u(new n("IQ", 23, "U04F03A12", "IQ98NBIQ850123456789012")), u(new n("JO", 30, "A04F22", "JO15AAAA1234567890123456789012")), u(new n("KW", 30, "U04A22", "KW81CBKU0000000000001234560101")), u(new n("KZ", 20, "F03A13", "KZ86125KZT5004100100")), u(new n("LB", 28, "F04A20", "LB62099900000001001901229114")), u(new n("LC", 32, "U04F24", "LC07HEMM000100010012001200013015")), u(new n("LI", 21, "F05A12", "LI21088100002324013AA")), u(new n("LT", 20, "F05F11", "LT121000011101001000")), u(new n("LU", 20, "F03A13", "LU280019400644750000")), u(new n("LV", 21, "U04A13", "LV80BANK0000435195001")), u(new n("MC", 27, "F05F05A11F02", "MC5811222000010123456789030")), u(new n("MD", 24, "U02A18", "MD24AG000225100013104168")), u(new n("ME", 22, "F03F13F02", "ME25505000012345678951")), u(new n("MK", 19, "F03A10F02", "MK07250120000058984")), u(new n("MR", 27, "F05F05F11F02", "MR1300020001010000123456753")), u(new n("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S")), u(new n("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR")), u(new n("NL", 18, "U04F10", "NL91ABNA0417164300")), u(new n("NO", 15, "F04F06F01", "NO9386011117947")), u(new n("PK", 24, "U04A16", "PK36SCBL0000001123456702")), u(new n("PL", 28, "F08F16", "PL61109010140000071219812874")), u(new n("PS", 29, "U04A21", "PS92PALS000000000400123456702")), u(new n("PT", 25, "F04F04F11F02", "PT50000201231234567890154")), u(new n("QA", 29, "U04A21", "QA30AAAA123456789012345678901")), u(new n("RO", 24, "U04A16", "RO49AAAA1B31007593840000")), u(new n("RS", 22, "F03F13F02", "RS35260005601001611379")), u(new n("SA", 24, "F02A18", "SA0380000000608010167519")), u(new n("SC", 31, "U04F04F16U03", "SC18SSCB11010000000000001497USD")), u(new n("SE", 24, "F03F16F01", "SE4550000000058398257466")), u(new n("SI", 19, "F05F08F02", "SI56263300012039086")), u(new n("SK", 24, "F04F06F10", "SK3112000000198742637541")), u(new n("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100")), u(new n("ST", 25, "F08F11F02", "ST68000100010051845310112")), u(new n("SV", 28, "U04F20", "SV62CENR00000000000000700025")), u(new n("TL", 23, "F03F14F02", "TL380080012345678910157")), u(new n("TN", 24, "F02F03F13F02", "TN5910006035183598478831")), u(new n("TR", 26, "F05F01A16", "TR330006100519786457841326")), u(new n("UA", 29, "F25", "UA511234567890123456789012345")), u(new n("VA", 22, "F18", "VA59001123000012345678")), u(new n("VG", 24, "U04F16", "VG96VPVG0000012345678901")), u(new n("XK", 20, "F04F10F02", "XK051212012345678906")), u(new n("AO", 25, "F21", "AO69123456789012345678901")), u(new n("BF", 27, "F23", "BF2312345678901234567890123")), u(new n("BI", 16, "F12", "BI41123456789012")), u(new n("BJ", 28, "F24", "BJ39123456789012345678901234")), u(new n("CI", 28, "U02F22", "CI70CI1234567890123456789012")), u(new n("CM", 27, "F23", "CM9012345678901234567890123")), u(new n("CV", 25, "F21", "CV30123456789012345678901")), u(new n("DZ", 24, "F20", "DZ8612345678901234567890")), u(new n("IR", 26, "F22", "IR861234568790123456789012")), u(new n("MG", 27, "F23", "MG1812345678901234567890123")), u(new n("ML", 28, "U01F23", "ML15A12345678901234567890123")), u(new n("MZ", 25, "F21", "MZ25123456789012345678901")), u(new n("SN", 28, "U01F23", "SN52A12345678901234567890123")), u(new n("GF", 27, "F05F05A11F02", "GF121234512345123456789AB13")), u(new n("GP", 27, "F05F05A11F02", "GP791234512345123456789AB13")), u(new n("MQ", 27, "F05F05A11F02", "MQ221234512345123456789AB13")), u(new n("RE", 27, "F05F05A11F02", "RE131234512345123456789AB13")), u(new n("PF", 27, "F05F05A11F02", "PF281234512345123456789AB13")), u(new n("TF", 27, "F05F05A11F02", "TF891234512345123456789AB13")), u(new n("YT", 27, "F05F05A11F02", "YT021234512345123456789AB13")), u(new n("NC", 27, "F05F05A11F02", "NC551234512345123456789AB13")), u(new n("BL", 27, "F05F05A11F02", "BL391234512345123456789AB13")), u(new n("MF", 27, "F05F05A11F02", "MF551234512345123456789AB13")), u(new n("PM", 27, "F05F05A11F02", "PM071234512345123456789AB13")), u(new n("WF", 27, "F05F05A11F02", "WF621234512345123456789AB13"));
      var d = /[^a-zA-Z0-9]/g,
        f = /(.{4})(?!$)/g;
      function _(e) {
        return "string" == typeof e || e instanceof String;
      }
      e.isValid = function (e) {
        if (!_(e)) return !1;
        e = i(e);
        var n = o[e.slice(0, 2)];
        return !!n && n.isValid(e);
      }, e.toBBAN = function (e, n) {
        void 0 === n && (n = " "), e = i(e);
        var r = o[e.slice(0, 2)];
        if (r) return r.toBBAN(e, n);
        throw new Error("No country with code " + e.slice(0, 2));
      }, e.fromBBAN = function (e, n) {
        var r = o[e];
        if (r) return r.fromBBAN(i(n));
        throw new Error("No country with code " + e);
      }, e.isValidBBAN = function (e, n) {
        return !!_(n) && (e = o[e]) && e.isValidBBAN(i(n));
      }, e.printFormat = function (e, n) {
        return void 0 === n && (n = " "), i(e).replace(f, "$1" + n);
      }, e.electronicFormat = i, e.countries = o;
    }, "string" != typeof n.nodeName ? t(n) : t(r.IBAN = {});
  }),
  format = function (e) {
    return iban.printFormat(e, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : " ");
  },
  mod97 = function (e) {
    return e - 97 * Math.floor(e / 97);
  };
function twoDigits(e) {
  return e < 10 ? "0" + e : "" + e;
}
var KT_ACCOUNT_PREFIX = {
    BEL: 651,
    LUX: 359
  },
  SITE_BRANCH = {
    BEL: "BEL",
    LUX: "LUX"
  },
  IBAN_PREFIX = {
    BEL: "BE",
    LUX: "LU"
  },
  ACCOUNTID_LENGTH = 7,
  getBBANfromAccountId = function (e) {
    var n,
      r = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).country,
      r = void 0 === r ? SITE_BRANCH.BEL : r;
    return r in SITE_BRANCH && r in KT_ACCOUNT_PREFIX ? r === SITE_BRANCH.LUX ? (n = 0 === (n = mod97(parseInt(e))) ? "97" : twoDigits(n), (1e3 * (359e10 + parseInt("" + e + n))).toString()) : (n = "" + KT_ACCOUNT_PREFIX[r] + e) + (r = 0 === (r = mod97(parseInt(n, 10))) ? "97" : twoDigits(r)) : e.toString();
  },
  getIBANfromAccountId = function (e) {
    var n,
      r = (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}).country,
      r = void 0 === r ? SITE_BRANCH.BEL : r;
    return r in SITE_BRANCH ? (n = getBBANfromAccountId(e, {
      country: r
    }), r === SITE_BRANCH.LUX ? iban.fromBBAN(IBAN_PREFIX.LUX, n) : iban.fromBBAN(IBAN_PREFIX.BEL, n)) : e.toString();
  },
  getAccountIdFromIBAN = function (e) {
    return +e.replace(/[\W_]+/g, "").slice(7, 7 + ACCOUNTID_LENGTH);
  },
  iban$1 = {
    format: format,
    getBBANfromAccountId: getBBANfromAccountId,
    getIBANfromAccountId: getIBANfromAccountId,
    getAccountIdFromIBAN: getAccountIdFromIBAN
  },
  CARD_VISA = "5071",
  CARD_VISA_GOLD = "5072",
  BENEFICIARY = "beneficiaries";
function maskIBAN(e, n) {
  return [CARD_VISA, CARD_VISA_GOLD].includes(n) ? e.substr(0, 7) + "** ****" + e.substr(14) : e;
}
var removeSpecialChars = function (e) {
    return e ? e.replace(/[^a-zA-Z0-9- ]/g, "") : "";
  },
  getCustomerFriendlyAccountNumber = function (e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
      r = e.isTrading || e.isInvestment || e.isTreeTop,
      t = e.type === BENEFICIARY ? e.accountNum : e.IBAN;
    return e.contractNumber || (r = r ? e.accountID : removeSpecialChars(t), maskIBAN(n ? format(r.toString()) : r.toString(), e.accountType));
  },
  _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  slicedToArray = function (e, n) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) {
      var r = n,
        t = [],
        a = !0,
        n = !1,
        s = void 0;
      try {
        for (var i, o = e[Symbol.iterator](); !(a = (i = o.next()).done) && (t.push(i.value), !r || t.length !== r); a = !0);
      } catch (e) {
        n = !0, s = e;
      } finally {
        try {
          !a && o.return && o.return();
        } finally {
          if (n) throw s;
        }
      }
      return t;
    }
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
  toArray = function (e) {
    return Array.isArray(e) ? e : Array.from(e);
  },
  MASK = "*",
  REGEX_ALLOWED_CHARS = /[^0-9A-Z]/g,
  creditCardNumber = function (e, n, r) {
    var t = {
        startMaskPos: 6,
        endMaskPos: 12
      },
      r = (null !== r && "object" === (void 0 === r ? "undefined" : _typeof(r)) && (t = Object.assign(t, r)), String(e).replace(REGEX_ALLOWED_CHARS, ""));
    return r ? (r = n ? r : "" + r.substring(0, t.startMaskPos) + MASK.repeat(t.endMaskPos - t.startMaskPos) + r.substring(t.endMaskPos)).replace(/(?!^)(?=(?:[A-Z0-9*]{4})+(?:\.|$))/gm, " ") : "";
  },
  dateTime = {
    convertLocalToUniversalTimeStamp: function (e) {
      return null === e ? e : ((e = new Date(1e3 * e)).getTime() + 6e4 * e.getTimezoneOffset()) / 1e3;
    }
  },
  SEPARATOR_THOUSANDS = " ",
  SEPARATOR_DECIMALS = ",",
  REGEX_NUMBERS = /[^0-9 .,-]/g,
  REGEX_THOUSANDS = /\B(?=(\d{3})+(?!\d))/g;
function number(e) {
  var n,
    r,
    t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2,
    a = arguments[2],
    s = {
      forceCommas: !1,
      forceFloat: !0,
      zeroValue: 0,
      limitDecimals: !0,
      thousandsSeparator: SEPARATOR_THOUSANDS,
      decimalSeparator: SEPARATOR_DECIMALS,
      allowPrecision: !1
    },
    a = (null !== a && "object" === (void 0 === a ? "undefined" : _typeof(a)) && (s = Object.assign(s, a)), String(e).replace(REGEX_NUMBERS, "")),
    i = a.includes(",") || a.includes("."),
    o = 1 / Math.pow(10, t || 1);
  return String(e).match(REGEX_NUMBERS) || (e = String(a).replace(s.decimalSeparator, ".").replace(/\s/g, ""), n = Math.pow(10, t), r = void 0, r = s.forceFloat && s.limitDecimals ? (Math.round(e + "e+" + t) / n).toFixed(t) : s.limitDecimals && !s.allowPrecision ? (Math.round(e + "e+" + t) / n).toString() : e, !a && 0 !== a) || isNaN(parseFloat(r)) ? "" : 0 !== s.zeroValue && parseFloat(a) < o ? s.zeroValue : (n = r.split(/[.,]/), a = (e = slicedToArray(n, 2))[0], r = void 0 === (o = e[1]) ? "" : o, 4 < (a = a.replace(/\s/gi, "")).replace("-", "").length && (a = a.replace(REGEX_THOUSANDS, s.thousandsSeparator)), s.limitDecimals && (r = r ? r.substr(0, t) : ""), s.forceCommas ? [a, r].join(s.decimalSeparator) : s.allowPrecision ? i ? [a, r].join(s.decimalSeparator) : a : r.length ? [a, r].join(s.decimalSeparator) : a);
}
function convertAmountFromCentsToEuros(e) {
  return e / 100;
}
var money = function (e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "EUR";
    return number(e, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 2, arguments[3]) + " " + n;
  },
  DEFAULT_INT_PREFIX = "00";
function formatBelgianMobileNumber(e) {
  var n;
  return !!(e && 10 < e.length) && "+" + (n = (n = e).substr(0, 2) === DEFAULT_INT_PREFIX ? e.substr(2) : n).substr(0, 2) + " " + n.substr(2, 3) + " " + n.substr(5, 2) + " " + n.substr(7, 2) + " " + n.substr(9, 2);
}
var phone = {
    formatBelgianMobileNumber: formatBelgianMobileNumber
  },
  formatTradingPrice = function (e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2,
      r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0,
      t = !(3 < arguments.length && void 0 !== arguments[3]) || arguments[3];
    if (null === n && (n = 2), !e) {
      if (isNaN(r)) return r;
      e = r;
    }
    return number(e, n, t ? {} : {
      thousandsSeparator: "",
      decimalSeparator: "."
    });
  },
  price = {
    formatTradingPrice: formatTradingPrice
  },
  SPACES_REGEX = /\s*/g,
  DECIMAL_SEPARATOR_REGEX = /[,.]/g,
  stringToNumber = function (e) {
    return parseFloat(("" + e).replace(SPACES_REGEX, "").replace(DECIMAL_SEPARATOR_REGEX, "."));
  },
  structuredMessage = function (e) {
    var n, r;
    return e ? (r = (e = e.replace(/[^0-9]/g, "")).slice(0, 3), n = e.slice(3, 7), e = e.slice(7, 12), "" + r + (r = function (e) {
      return e ? "/" : "";
    })(n) + n + r(e) + e) : "";
  };
function isDate(e) {
  return e instanceof Date;
}
var is_date = isDate,
  MILLISECONDS_IN_HOUR = 36e5,
  MILLISECONDS_IN_MINUTE = 6e4,
  DEFAULT_ADDITIONAL_DIGITS = 2,
  parseTokenDateTimeDelimeter = /[T ]/,
  parseTokenPlainTime = /:/,
  parseTokenYY = /^(\d{2})$/,
  parseTokensYYY = [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
  parseTokenYYYY = /^(\d{4})/,
  parseTokensYYYYY = [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
  parseTokenMM = /^-(\d{2})$/,
  parseTokenDDD = /^-?(\d{3})$/,
  parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/,
  parseTokenWww = /^-?W(\d{2})$/,
  parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/,
  parseTokenHH = /^(\d{2}([.,]\d*)?)$/,
  parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  parseTokenTimezone = /([Z+-].*)$/,
  parseTokenTimezoneZ = /^(Z)$/,
  parseTokenTimezoneHH = /^([+-])(\d{2})$/,
  parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;
function parse(e, n) {
  var r, t, a;
  return is_date(e) ? new Date(e.getTime()) : "string" == typeof e && (n = null == (n = (n || {}).additionalDigits) ? DEFAULT_ADDITIONAL_DIGITS : Number(n), t = (n = parseYear((r = splitDateString(e)).date, n)).year, n = parseDate(n.restDateString, t)) ? (t = n.getTime(), n = 0, r.time && (n = parseTime(r.time)), a = r.timezone ? parseTimezone(r.timezone) : (a = new Date(t + n).getTimezoneOffset(), new Date(t + n + a * MILLISECONDS_IN_MINUTE).getTimezoneOffset()), new Date(t + n + a * MILLISECONDS_IN_MINUTE)) : new Date(e);
}
function splitDateString(e) {
  var n,
    r = {},
    e = e.split(parseTokenDateTimeDelimeter),
    e = parseTokenPlainTime.test(e[0]) ? (r.date = null, e[0]) : (r.date = e[0], e[1]);
  return e && ((n = parseTokenTimezone.exec(e)) ? (r.time = e.replace(n[1], ""), r.timezone = n[1]) : r.time = e), r;
}
function parseYear(e, n) {
  var r,
    t = parseTokensYYY[n],
    n = parseTokensYYYYY[n],
    n = parseTokenYYYY.exec(e) || n.exec(e);
  return n ? (r = n[1], {
    year: parseInt(r, 10),
    restDateString: e.slice(r.length)
  }) : (n = parseTokenYY.exec(e) || t.exec(e)) ? (r = n[1], {
    year: 100 * parseInt(r, 10),
    restDateString: e.slice(r.length)
  }) : {
    year: null
  };
}
function parseDate(e, n) {
  var r, t, a, s;
  return null === n ? null : 0 === e.length ? ((t = new Date(0)).setUTCFullYear(n), t) : (r = parseTokenMM.exec(e)) ? (t = new Date(0), a = parseInt(r[1], 10) - 1, t.setUTCFullYear(n, a), t) : (r = parseTokenDDD.exec(e)) ? (t = new Date(0), s = parseInt(r[1], 10), t.setUTCFullYear(n, 0, s), t) : (r = parseTokenMMDD.exec(e)) ? (t = new Date(0), a = parseInt(r[1], 10) - 1, s = parseInt(r[2], 10), t.setUTCFullYear(n, a, s), t) : (r = parseTokenWww.exec(e)) ? dayOfISOYear(n, parseInt(r[1], 10) - 1) : (r = parseTokenWwwD.exec(e)) ? dayOfISOYear(n, parseInt(r[1], 10) - 1, parseInt(r[2], 10) - 1) : null;
}
function parseTime(e) {
  var n,
    r,
    t = parseTokenHH.exec(e);
  return t ? (n = parseFloat(t[1].replace(",", "."))) % 24 * MILLISECONDS_IN_HOUR : (t = parseTokenHHMM.exec(e)) ? (n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), n % 24 * MILLISECONDS_IN_HOUR + r * MILLISECONDS_IN_MINUTE) : (t = parseTokenHHMMSS.exec(e)) ? (n = parseInt(t[1], 10), r = parseInt(t[2], 10), e = parseFloat(t[3].replace(",", ".")), n % 24 * MILLISECONDS_IN_HOUR + r * MILLISECONDS_IN_MINUTE + 1e3 * e) : null;
}
function parseTimezone(e) {
  var n,
    r = parseTokenTimezoneZ.exec(e);
  return r ? 0 : (r = parseTokenTimezoneHH.exec(e)) ? (n = 60 * parseInt(r[2], 10), "+" === r[1] ? -n : n) : (r = parseTokenTimezoneHHMM.exec(e)) ? (n = 60 * parseInt(r[2], 10) + parseInt(r[3], 10), "+" === r[1] ? -n : n) : 0;
}
function dayOfISOYear(e, n, r) {
  n = n || 0, r = r || 0;
  var t = new Date(0);
  t.setUTCFullYear(e, 0, 4);
  e = 7 * n + r + 1 - (t.getUTCDay() || 7);
  return t.setUTCDate(t.getUTCDate() + e), t;
}
var parse_1 = parse;
function addDays(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setDate(e.getDate() + n), e;
}
var add_days = addDays;
function addMilliseconds(e, n) {
  e = parse_1(e).getTime(), n = Number(n);
  return new Date(e + n);
}
var add_milliseconds = addMilliseconds,
  MILLISECONDS_IN_HOUR$1 = 36e5;
function addHours(e, n) {
  n = Number(n);
  return add_milliseconds(e, n * MILLISECONDS_IN_HOUR$1);
}
var add_hours = addHours;
function startOfWeek(e, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    e = parse_1(e),
    r = e.getDay(),
    r = (r < n ? 7 : 0) + r - n;
  return e.setDate(e.getDate() - r), e.setHours(0, 0, 0, 0), e;
}
var start_of_week = startOfWeek;
function startOfISOWeek(e) {
  return start_of_week(e, {
    weekStartsOn: 1
  });
}
var start_of_iso_week = startOfISOWeek;
function getISOYear(e) {
  var e = parse_1(e),
    n = e.getFullYear(),
    r = new Date(0),
    r = (r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0), start_of_iso_week(r)),
    t = new Date(0),
    t = (t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), start_of_iso_week(t));
  return e.getTime() >= r.getTime() ? n + 1 : e.getTime() >= t.getTime() ? n : n - 1;
}
var get_iso_year = getISOYear;
function startOfISOYear(e) {
  var e = get_iso_year(e),
    n = new Date(0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), start_of_iso_week(n);
}
var start_of_iso_year = startOfISOYear;
function startOfDay(e) {
  e = parse_1(e);
  return e.setHours(0, 0, 0, 0), e;
}
var start_of_day = startOfDay,
  MILLISECONDS_IN_MINUTE$1 = 6e4,
  MILLISECONDS_IN_DAY = 864e5;
function differenceInCalendarDays(e, n) {
  e = start_of_day(e), n = start_of_day(n), e = e.getTime() - e.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1, n = n.getTime() - n.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$1;
  return Math.round((e - n) / MILLISECONDS_IN_DAY);
}
var difference_in_calendar_days = differenceInCalendarDays;
function setISOYear(e, n) {
  var e = parse_1(e),
    n = Number(n),
    r = difference_in_calendar_days(e, start_of_iso_year(e)),
    t = new Date(0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), (e = start_of_iso_year(t)).setDate(e.getDate() + r), e;
}
var set_iso_year = setISOYear;
function addISOYears(e, n) {
  n = Number(n);
  return set_iso_year(e, get_iso_year(e) + n);
}
var add_iso_years = addISOYears,
  MILLISECONDS_IN_MINUTE$2 = 6e4;
function addMinutes(e, n) {
  n = Number(n);
  return add_milliseconds(e, n * MILLISECONDS_IN_MINUTE$2);
}
var add_minutes = addMinutes;
function getDaysInMonth(e) {
  var e = parse_1(e),
    n = e.getFullYear(),
    e = e.getMonth(),
    r = new Date(0);
  return r.setFullYear(n, e + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
var get_days_in_month = getDaysInMonth;
function addMonths(e, n) {
  var e = parse_1(e),
    n = Number(n),
    n = e.getMonth() + n,
    r = new Date(0),
    r = (r.setFullYear(e.getFullYear(), n, 1), r.setHours(0, 0, 0, 0), get_days_in_month(r));
  return e.setMonth(n, Math.min(r, e.getDate())), e;
}
var add_months = addMonths;
function addQuarters(e, n) {
  n = Number(n);
  return add_months(e, 3 * n);
}
var add_quarters = addQuarters;
function addSeconds(e, n) {
  n = Number(n);
  return add_milliseconds(e, 1e3 * n);
}
var add_seconds = addSeconds;
function addWeeks(e, n) {
  n = Number(n);
  return add_days(e, 7 * n);
}
var add_weeks = addWeeks;
function addYears(e, n) {
  n = Number(n);
  return add_months(e, 12 * n);
}
var add_years = addYears;
function areRangesOverlapping(e, n, r, t) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime(), r = parse_1(r).getTime(), t = parse_1(t).getTime();
  if (n < e || t < r) throw new Error("The start of the range cannot be after the end of the range");
  return e < t && r < n;
}
var are_ranges_overlapping = areRangesOverlapping;
function closestIndexTo(e, n) {
  var r, t, a;
  if (n instanceof Array) return r = parse_1(e).getTime(), n.forEach(function (e, n) {
    e = parse_1(e), e = Math.abs(r - e.getTime());
    (void 0 === t || e < a) && (t = n, a = e);
  }), t;
  throw new TypeError(toString.call(n) + " is not an instance of Array");
}
var closest_index_to = closestIndexTo;
function closestTo(e, n) {
  var r, t, a;
  if (n instanceof Array) return r = parse_1(e).getTime(), n.forEach(function (e) {
    var e = parse_1(e),
      n = Math.abs(r - e.getTime());
    (void 0 === t || n < a) && (t = e, a = n);
  }), t;
  throw new TypeError(toString.call(n) + " is not an instance of Array");
}
var closest_to = closestTo;
function compareAsc(e, n) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime();
  return e < n ? -1 : n < e ? 1 : 0;
}
var compare_asc = compareAsc;
function compareDesc(e, n) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime();
  return n < e ? -1 : e < n ? 1 : 0;
}
var compare_desc = compareDesc,
  MILLISECONDS_IN_MINUTE$3 = 6e4,
  MILLISECONDS_IN_WEEK = 6048e5;
function differenceInCalendarISOWeeks(e, n) {
  e = start_of_iso_week(e), n = start_of_iso_week(n), e = e.getTime() - e.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$3, n = n.getTime() - n.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$3;
  return Math.round((e - n) / MILLISECONDS_IN_WEEK);
}
var difference_in_calendar_iso_weeks = differenceInCalendarISOWeeks;
function differenceInCalendarISOYears(e, n) {
  return get_iso_year(e) - get_iso_year(n);
}
var difference_in_calendar_iso_years = differenceInCalendarISOYears;
function differenceInCalendarMonths(e, n) {
  e = parse_1(e), n = parse_1(n);
  return 12 * (e.getFullYear() - n.getFullYear()) + (e.getMonth() - n.getMonth());
}
var difference_in_calendar_months = differenceInCalendarMonths;
function getQuarter(e) {
  e = parse_1(e);
  return Math.floor(e.getMonth() / 3) + 1;
}
var get_quarter = getQuarter;
function differenceInCalendarQuarters(e, n) {
  e = parse_1(e), n = parse_1(n);
  return 4 * (e.getFullYear() - n.getFullYear()) + (get_quarter(e) - get_quarter(n));
}
var difference_in_calendar_quarters = differenceInCalendarQuarters,
  MILLISECONDS_IN_MINUTE$4 = 6e4,
  MILLISECONDS_IN_WEEK$1 = 6048e5;
function differenceInCalendarWeeks(e, n, r) {
  e = start_of_week(e, r), n = start_of_week(n, r), r = e.getTime() - e.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$4, e = n.getTime() - n.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$4;
  return Math.round((r - e) / MILLISECONDS_IN_WEEK$1);
}
var difference_in_calendar_weeks = differenceInCalendarWeeks;
function differenceInCalendarYears(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getFullYear() - n.getFullYear();
}
var difference_in_calendar_years = differenceInCalendarYears;
function differenceInDays(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_days(e, n));
  return e.setDate(e.getDate() - r * t), r * (t - (compare_asc(e, n) === -r));
}
var difference_in_days = differenceInDays;
function differenceInMilliseconds(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() - n.getTime();
}
var difference_in_milliseconds = differenceInMilliseconds,
  MILLISECONDS_IN_HOUR$2 = 36e5;
function differenceInHours(e, n) {
  e = difference_in_milliseconds(e, n) / MILLISECONDS_IN_HOUR$2;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_hours = differenceInHours;
function subISOYears(e, n) {
  n = Number(n);
  return add_iso_years(e, -n);
}
var sub_iso_years = subISOYears;
function differenceInISOYears(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_iso_years(e, n)),
    e = sub_iso_years(e, r * t);
  return r * (t - (compare_asc(e, n) === -r));
}
var difference_in_iso_years = differenceInISOYears,
  MILLISECONDS_IN_MINUTE$5 = 6e4;
function differenceInMinutes(e, n) {
  e = difference_in_milliseconds(e, n) / MILLISECONDS_IN_MINUTE$5;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_minutes = differenceInMinutes;
function differenceInMonths(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_months(e, n));
  return e.setMonth(e.getMonth() - r * t), r * (t - (compare_asc(e, n) === -r));
}
var difference_in_months = differenceInMonths;
function differenceInQuarters(e, n) {
  e = difference_in_months(e, n) / 3;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_quarters = differenceInQuarters;
function differenceInSeconds(e, n) {
  e = difference_in_milliseconds(e, n) / 1e3;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_seconds = differenceInSeconds;
function differenceInWeeks(e, n) {
  e = difference_in_days(e, n) / 7;
  return 0 < e ? Math.floor(e) : Math.ceil(e);
}
var difference_in_weeks = differenceInWeeks;
function differenceInYears(e, n) {
  var e = parse_1(e),
    n = parse_1(n),
    r = compare_asc(e, n),
    t = Math.abs(difference_in_calendar_years(e, n));
  return e.setFullYear(e.getFullYear() - r * t), r * (t - (compare_asc(e, n) === -r));
}
var difference_in_years = differenceInYears;
function buildDistanceInWordsLocale() {
  var t = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  };
  return {
    localize: function (e, n, r) {
      return r = r || {}, e = "string" == typeof t[e] ? t[e] : 1 === n ? t[e].one : t[e].other.replace("{{count}}", n), r.addSuffix ? 0 < r.comparison ? "in " + e : e + " ago" : e;
    }
  };
}
var build_distance_in_words_locale = buildDistanceInWordsLocale,
  commonFormatterKeys = ["M", "MM", "Q", "D", "DD", "DDD", "DDDD", "d", "E", "W", "WW", "YY", "YYYY", "GG", "GGGG", "H", "HH", "h", "hh", "m", "mm", "s", "ss", "S", "SS", "SSS", "Z", "ZZ", "X", "x"];
function buildFormattingTokensRegExp(e) {
  var n,
    r = [];
  for (n in e) e.hasOwnProperty(n) && r.push(n);
  var t = commonFormatterKeys.concat(r).sort().reverse();
  return new RegExp("(\\[[^\\[]*\\])|(\\\\)?(" + t.join("|") + "|.)", "g");
}
var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;
function buildFormatLocale() {
  var n = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    r = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    t = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    a = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    s = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    i = ["AM", "PM"],
    o = ["am", "pm"],
    u = ["a.m.", "p.m."],
    e = {
      MMM: function (e) {
        return n[e.getMonth()];
      },
      MMMM: function (e) {
        return r[e.getMonth()];
      },
      dd: function (e) {
        return t[e.getDay()];
      },
      ddd: function (e) {
        return a[e.getDay()];
      },
      dddd: function (e) {
        return s[e.getDay()];
      },
      A: function (e) {
        return 1 <= e.getHours() / 12 ? i[1] : i[0];
      },
      a: function (e) {
        return 1 <= e.getHours() / 12 ? o[1] : o[0];
      },
      aa: function (e) {
        return 1 <= e.getHours() / 12 ? u[1] : u[0];
      }
    };
  return ["M", "D", "DDD", "d", "Q", "W"].forEach(function (r) {
    e[r + "o"] = function (e, n) {
      return ordinal(n[r](e));
    };
  }), {
    formatters: e,
    formattingTokensRegExp: build_formatting_tokens_reg_exp(e)
  };
}
function ordinal(e) {
  var n = e % 100;
  if (20 < n || n < 10) switch (n % 10) {
    case 1:
      return e + "st";
    case 2:
      return e + "nd";
    case 3:
      return e + "rd";
  }
  return e + "th";
}
var build_format_locale = buildFormatLocale,
  en = {
    distanceInWords: buildDistanceInWordsLocale(),
    format: build_format_locale()
  },
  MINUTES_IN_DAY = 1440,
  MINUTES_IN_ALMOST_TWO_DAYS = 2520,
  MINUTES_IN_MONTH = 43200,
  MINUTES_IN_TWO_MONTHS = 86400;
function distanceInWords(e, n, r) {
  var t,
    a,
    r = r || {},
    s = compare_desc(e, n),
    i = r.locale,
    o = en.distanceInWords.localize,
    i = (i && i.distanceInWords && i.distanceInWords.localize && (o = i.distanceInWords.localize), {
      addSuffix: Boolean(r.addSuffix),
      comparison: s
    }),
    s = 0 < s ? (t = parse_1(e), parse_1(n)) : (t = parse_1(n), parse_1(e)),
    n = difference_in_seconds(s, t),
    e = s.getTimezoneOffset() - t.getTimezoneOffset(),
    e = Math.round(n / 60) - e;
  return e < 2 ? r.includeSeconds ? n < 5 ? o("lessThanXSeconds", 5, i) : n < 10 ? o("lessThanXSeconds", 10, i) : n < 20 ? o("lessThanXSeconds", 20, i) : n < 40 ? o("halfAMinute", null, i) : o(n < 60 ? "lessThanXMinutes" : "xMinutes", 1, i) : 0 == e ? o("lessThanXMinutes", 1, i) : o("xMinutes", e, i) : e < 45 ? o("xMinutes", e, i) : e < 90 ? o("aboutXHours", 1, i) : e < MINUTES_IN_DAY ? o("aboutXHours", Math.round(e / 60), i) : e < MINUTES_IN_ALMOST_TWO_DAYS ? o("xDays", 1, i) : e < MINUTES_IN_MONTH ? o("xDays", Math.round(e / MINUTES_IN_DAY), i) : e < MINUTES_IN_TWO_MONTHS ? o("aboutXMonths", a = Math.round(e / MINUTES_IN_MONTH), i) : (a = difference_in_months(s, t)) < 12 ? o("xMonths", Math.round(e / MINUTES_IN_MONTH), i) : (r = a % 12, n = Math.floor(a / 12), r < 3 ? o("aboutXYears", n, i) : r < 9 ? o("overXYears", n, i) : o("almostXYears", n + 1, i));
}
var distance_in_words = distanceInWords,
  MINUTES_IN_DAY$1 = 1440,
  MINUTES_IN_MONTH$1 = 43200,
  MINUTES_IN_YEAR = 525600;
function distanceInWordsStrict(e, n, r) {
  var r = r || {},
    t = compare_desc(e, n),
    a = r.locale,
    s = en.distanceInWords.localize,
    a = (a && a.distanceInWords && a.distanceInWords.localize && (s = a.distanceInWords.localize), {
      addSuffix: Boolean(r.addSuffix),
      comparison: t
    }),
    t = 0 < t ? (i = parse_1(e), parse_1(n)) : (i = parse_1(n), parse_1(e)),
    n = Math[r.partialMethod ? String(r.partialMethod) : "floor"],
    e = difference_in_seconds(t, i),
    t = t.getTimezoneOffset() - i.getTimezoneOffset(),
    i = n(e / 60) - t,
    t = r.unit ? String(r.unit) : i < 1 ? "s" : i < 60 ? "m" : i < MINUTES_IN_DAY$1 ? "h" : i < MINUTES_IN_MONTH$1 ? "d" : i < MINUTES_IN_YEAR ? "M" : "Y";
  if ("s" === t) return s("xSeconds", e, a);
  if ("m" === t) return s("xMinutes", i, a);
  if ("h" === t) return s("xHours", n(i / 60), a);
  if ("d" === t) return s("xDays", n(i / MINUTES_IN_DAY$1), a);
  if ("M" === t) return s("xMonths", n(i / MINUTES_IN_MONTH$1), a);
  if ("Y" === t) return s("xYears", n(i / MINUTES_IN_YEAR), a);
  throw new Error("Unknown unit: " + t);
}
var distance_in_words_strict = distanceInWordsStrict;
function distanceInWordsToNow(e, n) {
  return distance_in_words(Date.now(), e, n);
}
var distance_in_words_to_now = distanceInWordsToNow;
function eachDay(e, n, r) {
  var e = parse_1(e),
    t = void 0 !== r ? r : 1,
    a = parse_1(n).getTime();
  if (e.getTime() > a) throw new Error("The first date cannot be after the second date");
  var s = [],
    i = e;
  for (i.setHours(0, 0, 0, 0); i.getTime() <= a;) s.push(parse_1(i)), i.setDate(i.getDate() + t);
  return s;
}
var each_day = eachDay;
function endOfDay(e) {
  e = parse_1(e);
  return e.setHours(23, 59, 59, 999), e;
}
var end_of_day = endOfDay;
function endOfHour(e) {
  e = parse_1(e);
  return e.setMinutes(59, 59, 999), e;
}
var end_of_hour = endOfHour;
function endOfWeek(e, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    e = parse_1(e),
    r = e.getDay(),
    r = 6 + (r < n ? -7 : 0) - (r - n);
  return e.setDate(e.getDate() + r), e.setHours(23, 59, 59, 999), e;
}
var end_of_week = endOfWeek;
function endOfISOWeek(e) {
  return end_of_week(e, {
    weekStartsOn: 1
  });
}
var end_of_iso_week = endOfISOWeek;
function endOfISOYear(e) {
  var e = get_iso_year(e),
    n = new Date(0),
    e = (n.setFullYear(e + 1, 0, 4), n.setHours(0, 0, 0, 0), start_of_iso_week(n));
  return e.setMilliseconds(e.getMilliseconds() - 1), e;
}
var end_of_iso_year = endOfISOYear;
function endOfMinute(e) {
  e = parse_1(e);
  return e.setSeconds(59, 999), e;
}
var end_of_minute = endOfMinute;
function endOfMonth(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
var end_of_month = endOfMonth;
function endOfQuarter(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setMonth(n - n % 3 + 3, 0), e.setHours(23, 59, 59, 999), e;
}
var end_of_quarter = endOfQuarter;
function endOfSecond(e) {
  e = parse_1(e);
  return e.setMilliseconds(999), e;
}
var end_of_second = endOfSecond;
function endOfToday() {
  return end_of_day(new Date());
}
var end_of_today = endOfToday;
function endOfTomorrow() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e + 1), t.setHours(23, 59, 59, 999), t;
}
var end_of_tomorrow = endOfTomorrow;
function endOfYear(e) {
  var e = parse_1(e),
    n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
var end_of_year = endOfYear;
function endOfYesterday() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e - 1), t.setHours(23, 59, 59, 999), t;
}
var end_of_yesterday = endOfYesterday;
function startOfYear(e) {
  var e = parse_1(e),
    n = new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
var start_of_year = startOfYear;
function getDayOfYear(e) {
  e = parse_1(e);
  return difference_in_calendar_days(e, start_of_year(e)) + 1;
}
var get_day_of_year = getDayOfYear,
  MILLISECONDS_IN_WEEK$2 = 6048e5;
function getISOWeek(e) {
  e = parse_1(e), e = start_of_iso_week(e).getTime() - start_of_iso_year(e).getTime();
  return Math.round(e / MILLISECONDS_IN_WEEK$2) + 1;
}
var get_iso_week = getISOWeek;
function isValid$1(e) {
  if (is_date(e)) return !isNaN(e);
  throw new TypeError(toString.call(e) + " is not an instance of Date");
}
var is_valid = isValid$1;
function format$1(e, n, r) {
  var n = n ? String(n) : "YYYY-MM-DDTHH:mm:ss.SSSZ",
    r = (r || {}).locale,
    t = en.format.formatters,
    a = en.format.formattingTokensRegExp,
    r = (r && r.format && r.format.formatters && (t = r.format.formatters, r.format.formattingTokensRegExp) && (a = r.format.formattingTokensRegExp), parse_1(e));
  return is_valid(r) ? buildFormatFn(n, t, a)(r) : "Invalid Date";
}
var formatters = {
  M: function (e) {
    return e.getMonth() + 1;
  },
  MM: function (e) {
    return addLeadingZeros(e.getMonth() + 1, 2);
  },
  Q: function (e) {
    return Math.ceil((e.getMonth() + 1) / 3);
  },
  D: function (e) {
    return e.getDate();
  },
  DD: function (e) {
    return addLeadingZeros(e.getDate(), 2);
  },
  DDD: function (e) {
    return get_day_of_year(e);
  },
  DDDD: function (e) {
    return addLeadingZeros(get_day_of_year(e), 3);
  },
  d: function (e) {
    return e.getDay();
  },
  E: function (e) {
    return e.getDay() || 7;
  },
  W: function (e) {
    return get_iso_week(e);
  },
  WW: function (e) {
    return addLeadingZeros(get_iso_week(e), 2);
  },
  YY: function (e) {
    return addLeadingZeros(e.getFullYear(), 4).substr(2);
  },
  YYYY: function (e) {
    return addLeadingZeros(e.getFullYear(), 4);
  },
  GG: function (e) {
    return String(get_iso_year(e)).substr(2);
  },
  GGGG: function (e) {
    return get_iso_year(e);
  },
  H: function (e) {
    return e.getHours();
  },
  HH: function (e) {
    return addLeadingZeros(e.getHours(), 2);
  },
  h: function (e) {
    e = e.getHours();
    return 0 === e ? 12 : 12 < e ? e % 12 : e;
  },
  hh: function (e) {
    return addLeadingZeros(formatters.h(e), 2);
  },
  m: function (e) {
    return e.getMinutes();
  },
  mm: function (e) {
    return addLeadingZeros(e.getMinutes(), 2);
  },
  s: function (e) {
    return e.getSeconds();
  },
  ss: function (e) {
    return addLeadingZeros(e.getSeconds(), 2);
  },
  S: function (e) {
    return Math.floor(e.getMilliseconds() / 100);
  },
  SS: function (e) {
    return addLeadingZeros(Math.floor(e.getMilliseconds() / 10), 2);
  },
  SSS: function (e) {
    return addLeadingZeros(e.getMilliseconds(), 3);
  },
  Z: function (e) {
    return formatTimezone(e.getTimezoneOffset(), ":");
  },
  ZZ: function (e) {
    return formatTimezone(e.getTimezoneOffset());
  },
  X: function (e) {
    return Math.floor(e.getTime() / 1e3);
  },
  x: function (e) {
    return e.getTime();
  }
};
function buildFormatFn(e, n, r) {
  for (var t, a = e.match(r), s = a.length, i = 0; i < s; i++) t = n[a[i]] || formatters[a[i]], a[i] = t || removeFormattingTokens(a[i]);
  return function (e) {
    for (var n = "", r = 0; r < s; r++) a[r] instanceof Function ? n += a[r](e, formatters) : n += a[r];
    return n;
  };
}
function removeFormattingTokens(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|]$/g, "") : e.replace(/\\/g, "");
}
function formatTimezone(e, n) {
  n = n || "";
  var r = 0 < e ? "-" : "+",
    e = Math.abs(e),
    t = e % 60;
  return r + addLeadingZeros(Math.floor(e / 60), 2) + n + addLeadingZeros(t, 2);
}
function addLeadingZeros(e, n) {
  for (var r = Math.abs(e).toString(); r.length < n;) r = "0" + r;
  return r;
}
var format_1 = format$1;
function getDate(e) {
  return parse_1(e).getDate();
}
var get_date = getDate;
function getDay(e) {
  return parse_1(e).getDay();
}
var get_day = getDay;
function isLeapYear(e) {
  e = parse_1(e).getFullYear();
  return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
var is_leap_year = isLeapYear;
function getDaysInYear(e) {
  return is_leap_year(e) ? 366 : 365;
}
var get_days_in_year = getDaysInYear;
function getHours(e) {
  return parse_1(e).getHours();
}
var get_hours = getHours;
function getISODay(e) {
  e = parse_1(e).getDay();
  return e = 0 === e ? 7 : e;
}
var get_iso_day = getISODay,
  MILLISECONDS_IN_WEEK$3 = 6048e5;
function getISOWeeksInYear(e) {
  e = start_of_iso_year(e), e = start_of_iso_year(add_weeks(e, 60)).valueOf() - e.valueOf();
  return Math.round(e / MILLISECONDS_IN_WEEK$3);
}
var get_iso_weeks_in_year = getISOWeeksInYear;
function getMilliseconds(e) {
  return parse_1(e).getMilliseconds();
}
var get_milliseconds = getMilliseconds;
function getMinutes(e) {
  return parse_1(e).getMinutes();
}
var get_minutes = getMinutes;
function getMonth(e) {
  return parse_1(e).getMonth();
}
var get_month = getMonth,
  MILLISECONDS_IN_DAY$1 = 864e5;
function getOverlappingDaysInRanges(e, n, r, t) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime(), r = parse_1(r).getTime(), t = parse_1(t).getTime();
  if (n < e || t < r) throw new Error("The start of the range cannot be after the end of the range");
  return e < t && r < n ? Math.ceil(((n < t ? n : t) - (r < e ? e : r)) / MILLISECONDS_IN_DAY$1) : 0;
}
var get_overlapping_days_in_ranges = getOverlappingDaysInRanges;
function getSeconds(e) {
  return parse_1(e).getSeconds();
}
var get_seconds = getSeconds;
function getTime(e) {
  return parse_1(e).getTime();
}
var get_time = getTime;
function getYear(e) {
  return parse_1(e).getFullYear();
}
var get_year = getYear;
function isAfter(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() > n.getTime();
}
var is_after = isAfter;
function isBefore(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() < n.getTime();
}
var is_before = isBefore;
function isEqual(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getTime() === n.getTime();
}
var is_equal = isEqual;
function isFirstDayOfMonth(e) {
  return 1 === parse_1(e).getDate();
}
var is_first_day_of_month = isFirstDayOfMonth;
function isFriday(e) {
  return 5 === parse_1(e).getDay();
}
var is_friday = isFriday;
function isFuture(e) {
  return parse_1(e).getTime() > new Date().getTime();
}
var is_future = isFuture;
function isLastDayOfMonth(e) {
  e = parse_1(e);
  return end_of_day(e).getTime() === end_of_month(e).getTime();
}
var is_last_day_of_month = isLastDayOfMonth;
function isMonday(e) {
  return 1 === parse_1(e).getDay();
}
var is_monday = isMonday;
function isPast(e) {
  return parse_1(e).getTime() < new Date().getTime();
}
var is_past = isPast;
function isSameDay(e, n) {
  e = start_of_day(e), n = start_of_day(n);
  return e.getTime() === n.getTime();
}
var is_same_day = isSameDay;
function startOfHour(e) {
  e = parse_1(e);
  return e.setMinutes(0, 0, 0), e;
}
var start_of_hour = startOfHour;
function isSameHour(e, n) {
  e = start_of_hour(e), n = start_of_hour(n);
  return e.getTime() === n.getTime();
}
var is_same_hour = isSameHour;
function isSameWeek(e, n, r) {
  e = start_of_week(e, r), n = start_of_week(n, r);
  return e.getTime() === n.getTime();
}
var is_same_week = isSameWeek;
function isSameISOWeek(e, n) {
  return is_same_week(e, n, {
    weekStartsOn: 1
  });
}
var is_same_iso_week = isSameISOWeek;
function isSameISOYear(e, n) {
  e = start_of_iso_year(e), n = start_of_iso_year(n);
  return e.getTime() === n.getTime();
}
var is_same_iso_year = isSameISOYear;
function startOfMinute(e) {
  e = parse_1(e);
  return e.setSeconds(0, 0), e;
}
var start_of_minute = startOfMinute;
function isSameMinute(e, n) {
  e = start_of_minute(e), n = start_of_minute(n);
  return e.getTime() === n.getTime();
}
var is_same_minute = isSameMinute;
function isSameMonth(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getFullYear() === n.getFullYear() && e.getMonth() === n.getMonth();
}
var is_same_month = isSameMonth;
function startOfQuarter(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setMonth(n - n % 3, 1), e.setHours(0, 0, 0, 0), e;
}
var start_of_quarter = startOfQuarter;
function isSameQuarter(e, n) {
  e = start_of_quarter(e), n = start_of_quarter(n);
  return e.getTime() === n.getTime();
}
var is_same_quarter = isSameQuarter;
function startOfSecond(e) {
  e = parse_1(e);
  return e.setMilliseconds(0), e;
}
var start_of_second = startOfSecond;
function isSameSecond(e, n) {
  e = start_of_second(e), n = start_of_second(n);
  return e.getTime() === n.getTime();
}
var is_same_second = isSameSecond;
function isSameYear(e, n) {
  e = parse_1(e), n = parse_1(n);
  return e.getFullYear() === n.getFullYear();
}
var is_same_year = isSameYear;
function isSaturday(e) {
  return 6 === parse_1(e).getDay();
}
var is_saturday = isSaturday;
function isSunday(e) {
  return 0 === parse_1(e).getDay();
}
var is_sunday = isSunday;
function isThisHour(e) {
  return is_same_hour(new Date(), e);
}
var is_this_hour = isThisHour;
function isThisISOWeek(e) {
  return is_same_iso_week(new Date(), e);
}
var is_this_iso_week = isThisISOWeek;
function isThisISOYear(e) {
  return is_same_iso_year(new Date(), e);
}
var is_this_iso_year = isThisISOYear;
function isThisMinute(e) {
  return is_same_minute(new Date(), e);
}
var is_this_minute = isThisMinute;
function isThisMonth(e) {
  return is_same_month(new Date(), e);
}
var is_this_month = isThisMonth;
function isThisQuarter(e) {
  return is_same_quarter(new Date(), e);
}
var is_this_quarter = isThisQuarter;
function isThisSecond(e) {
  return is_same_second(new Date(), e);
}
var is_this_second = isThisSecond;
function isThisWeek(e, n) {
  return is_same_week(new Date(), e, n);
}
var is_this_week = isThisWeek;
function isThisYear(e) {
  return is_same_year(new Date(), e);
}
var is_this_year = isThisYear;
function isThursday(e) {
  return 4 === parse_1(e).getDay();
}
var is_thursday = isThursday;
function isToday(e) {
  return start_of_day(e).getTime() === start_of_day(new Date()).getTime();
}
var is_today = isToday;
function isTomorrow(e) {
  var n = new Date();
  return n.setDate(n.getDate() + 1), start_of_day(e).getTime() === start_of_day(n).getTime();
}
var is_tomorrow = isTomorrow;
function isTuesday(e) {
  return 2 === parse_1(e).getDay();
}
var is_tuesday = isTuesday;
function isWednesday(e) {
  return 3 === parse_1(e).getDay();
}
var is_wednesday = isWednesday;
function isWeekend(e) {
  e = parse_1(e).getDay();
  return 0 === e || 6 === e;
}
var is_weekend = isWeekend;
function isWithinRange(e, n, r) {
  e = parse_1(e).getTime(), n = parse_1(n).getTime(), r = parse_1(r).getTime();
  if (r < n) throw new Error("The start of the range cannot be after the end of the range");
  return n <= e && e <= r;
}
var is_within_range = isWithinRange;
function isYesterday(e) {
  var n = new Date();
  return n.setDate(n.getDate() - 1), start_of_day(e).getTime() === start_of_day(n).getTime();
}
var is_yesterday = isYesterday;
function lastDayOfWeek(e, n) {
  var n = n && Number(n.weekStartsOn) || 0,
    e = parse_1(e),
    r = e.getDay(),
    r = 6 + (r < n ? -7 : 0) - (r - n);
  return e.setHours(0, 0, 0, 0), e.setDate(e.getDate() + r), e;
}
var last_day_of_week = lastDayOfWeek;
function lastDayOfISOWeek(e) {
  return last_day_of_week(e, {
    weekStartsOn: 1
  });
}
var last_day_of_iso_week = lastDayOfISOWeek;
function lastDayOfISOYear(e) {
  var e = get_iso_year(e),
    n = new Date(0),
    e = (n.setFullYear(e + 1, 0, 4), n.setHours(0, 0, 0, 0), start_of_iso_week(n));
  return e.setDate(e.getDate() - 1), e;
}
var last_day_of_iso_year = lastDayOfISOYear;
function lastDayOfMonth(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
var last_day_of_month = lastDayOfMonth;
function lastDayOfQuarter(e) {
  var e = parse_1(e),
    n = e.getMonth();
  return e.setMonth(n - n % 3 + 3, 0), e.setHours(0, 0, 0, 0), e;
}
var last_day_of_quarter = lastDayOfQuarter;
function lastDayOfYear(e) {
  var e = parse_1(e),
    n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(0, 0, 0, 0), e;
}
var last_day_of_year = lastDayOfYear;
function max() {
  var e = Array.prototype.slice.call(arguments).map(function (e) {
      return parse_1(e);
    }),
    e = Math.max.apply(null, e);
  return new Date(e);
}
var max_1 = max;
function min() {
  var e = Array.prototype.slice.call(arguments).map(function (e) {
      return parse_1(e);
    }),
    e = Math.min.apply(null, e);
  return new Date(e);
}
var min_1 = min;
function setDate(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setDate(n), e;
}
var set_date = setDate;
function setDay(e, n, r) {
  var r = r && Number(r.weekStartsOn) || 0,
    e = parse_1(e),
    n = Number(n),
    t = e.getDay();
  return add_days(e, ((7 + n % 7) % 7 < r ? 7 : 0) + n - t);
}
var set_day = setDay;
function setDayOfYear(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setMonth(0), e.setDate(n), e;
}
var set_day_of_year = setDayOfYear;
function setHours(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setHours(n), e;
}
var set_hours = setHours;
function setISODay(e, n) {
  var e = parse_1(e),
    n = Number(n),
    r = get_iso_day(e);
  return add_days(e, n - r);
}
var set_iso_day = setISODay;
function setISOWeek(e, n) {
  e = parse_1(e), n = Number(n), n = get_iso_week(e) - n;
  return e.setDate(e.getDate() - 7 * n), e;
}
var set_iso_week = setISOWeek;
function setMilliseconds(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setMilliseconds(n), e;
}
var set_milliseconds = setMilliseconds;
function setMinutes(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setMinutes(n), e;
}
var set_minutes = setMinutes;
function setMonth(e, n) {
  var e = parse_1(e),
    n = Number(n),
    r = e.getFullYear(),
    t = e.getDate(),
    a = new Date(0),
    r = (a.setFullYear(r, n, 15), a.setHours(0, 0, 0, 0), get_days_in_month(a));
  return e.setMonth(n, Math.min(t, r)), e;
}
var set_month = setMonth;
function setQuarter(e, n) {
  e = parse_1(e), n = Number(n) - (Math.floor(e.getMonth() / 3) + 1);
  return set_month(e, e.getMonth() + 3 * n);
}
var set_quarter = setQuarter;
function setSeconds(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setSeconds(n), e;
}
var set_seconds = setSeconds;
function setYear(e, n) {
  e = parse_1(e), n = Number(n);
  return e.setFullYear(n), e;
}
var set_year = setYear;
function startOfMonth(e) {
  e = parse_1(e);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
var start_of_month = startOfMonth;
function startOfToday() {
  return start_of_day(new Date());
}
var start_of_today = startOfToday;
function startOfTomorrow() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e + 1), t.setHours(0, 0, 0, 0), t;
}
var start_of_tomorrow = startOfTomorrow;
function startOfYesterday() {
  var e = new Date(),
    n = e.getFullYear(),
    r = e.getMonth(),
    e = e.getDate(),
    t = new Date(0);
  return t.setFullYear(n, r, e - 1), t.setHours(0, 0, 0, 0), t;
}
var start_of_yesterday = startOfYesterday;
function subDays(e, n) {
  n = Number(n);
  return add_days(e, -n);
}
var sub_days = subDays;
function subHours(e, n) {
  n = Number(n);
  return add_hours(e, -n);
}
var sub_hours = subHours;
function subMilliseconds(e, n) {
  n = Number(n);
  return add_milliseconds(e, -n);
}
var sub_milliseconds = subMilliseconds;
function subMinutes(e, n) {
  n = Number(n);
  return add_minutes(e, -n);
}
var sub_minutes = subMinutes;
function subMonths(e, n) {
  n = Number(n);
  return add_months(e, -n);
}
var sub_months = subMonths;
function subQuarters(e, n) {
  n = Number(n);
  return add_quarters(e, -n);
}
var sub_quarters = subQuarters;
function subSeconds(e, n) {
  n = Number(n);
  return add_seconds(e, -n);
}
var sub_seconds = subSeconds;
function subWeeks(e, n) {
  n = Number(n);
  return add_weeks(e, -n);
}
var sub_weeks = subWeeks;
function subYears(e, n) {
  n = Number(n);
  return add_years(e, -n);
}
var sub_years = subYears,
  dateFns = {
    addDays: add_days,
    addHours: add_hours,
    addISOYears: add_iso_years,
    addMilliseconds: add_milliseconds,
    addMinutes: add_minutes,
    addMonths: add_months,
    addQuarters: add_quarters,
    addSeconds: add_seconds,
    addWeeks: add_weeks,
    addYears: add_years,
    areRangesOverlapping: are_ranges_overlapping,
    closestIndexTo: closest_index_to,
    closestTo: closest_to,
    compareAsc: compare_asc,
    compareDesc: compare_desc,
    differenceInCalendarDays: difference_in_calendar_days,
    differenceInCalendarISOWeeks: difference_in_calendar_iso_weeks,
    differenceInCalendarISOYears: difference_in_calendar_iso_years,
    differenceInCalendarMonths: difference_in_calendar_months,
    differenceInCalendarQuarters: difference_in_calendar_quarters,
    differenceInCalendarWeeks: difference_in_calendar_weeks,
    differenceInCalendarYears: difference_in_calendar_years,
    differenceInDays: difference_in_days,
    differenceInHours: difference_in_hours,
    differenceInISOYears: difference_in_iso_years,
    differenceInMilliseconds: difference_in_milliseconds,
    differenceInMinutes: difference_in_minutes,
    differenceInMonths: difference_in_months,
    differenceInQuarters: difference_in_quarters,
    differenceInSeconds: difference_in_seconds,
    differenceInWeeks: difference_in_weeks,
    differenceInYears: difference_in_years,
    distanceInWords: distance_in_words,
    distanceInWordsStrict: distanceInWordsStrict,
    distanceInWordsToNow: distanceInWordsToNow,
    eachDay: eachDay,
    endOfDay: end_of_day,
    endOfHour: endOfHour,
    endOfISOWeek: endOfISOWeek,
    endOfISOYear: endOfISOYear,
    endOfMinute: endOfMinute,
    endOfMonth: end_of_month,
    endOfQuarter: endOfQuarter,
    endOfSecond: endOfSecond,
    endOfToday: endOfToday,
    endOfTomorrow: endOfTomorrow,
    endOfWeek: end_of_week,
    endOfYear: endOfYear,
    endOfYesterday: endOfYesterday,
    format: format$1,
    getDate: getDate,
    getDay: getDay,
    getDayOfYear: get_day_of_year,
    getDaysInMonth: get_days_in_month,
    getDaysInYear: getDaysInYear,
    getHours: getHours,
    getISODay: get_iso_day,
    getISOWeek: get_iso_week,
    getISOWeeksInYear: getISOWeeksInYear,
    getISOYear: get_iso_year,
    getMilliseconds: getMilliseconds,
    getMinutes: getMinutes,
    getMonth: getMonth,
    getOverlappingDaysInRanges: getOverlappingDaysInRanges,
    getQuarter: get_quarter,
    getSeconds: getSeconds,
    getTime: getTime,
    getYear: getYear,
    isAfter: isAfter,
    isBefore: isBefore,
    isDate: is_date,
    isEqual: isEqual,
    isFirstDayOfMonth: isFirstDayOfMonth,
    isFriday: isFriday,
    isFuture: isFuture,
    isLastDayOfMonth: isLastDayOfMonth,
    isLeapYear: is_leap_year,
    isMonday: isMonday,
    isPast: isPast,
    isSameDay: isSameDay,
    isSameHour: is_same_hour,
    isSameISOWeek: is_same_iso_week,
    isSameISOYear: is_same_iso_year,
    isSameMinute: is_same_minute,
    isSameMonth: is_same_month,
    isSameQuarter: is_same_quarter,
    isSameSecond: is_same_second,
    isSameWeek: is_same_week,
    isSameYear: is_same_year,
    isSaturday: isSaturday,
    isSunday: isSunday,
    isThisHour: isThisHour,
    isThisISOWeek: isThisISOWeek,
    isThisISOYear: isThisISOYear,
    isThisMinute: isThisMinute,
    isThisMonth: isThisMonth,
    isThisQuarter: isThisQuarter,
    isThisSecond: isThisSecond,
    isThisWeek: isThisWeek,
    isThisYear: isThisYear,
    isThursday: isThursday,
    isToday: isToday,
    isTomorrow: isTomorrow,
    isTuesday: isTuesday,
    isValid: is_valid,
    isWednesday: isWednesday,
    isWeekend: isWeekend,
    isWithinRange: isWithinRange,
    isYesterday: isYesterday,
    lastDayOfISOWeek: lastDayOfISOWeek,
    lastDayOfISOYear: lastDayOfISOYear,
    lastDayOfMonth: lastDayOfMonth,
    lastDayOfQuarter: lastDayOfQuarter,
    lastDayOfWeek: last_day_of_week,
    lastDayOfYear: lastDayOfYear,
    max: max,
    min: min,
    parse: parse_1,
    setDate: setDate,
    setDay: setDay,
    setDayOfYear: setDayOfYear,
    setHours: setHours,
    setISODay: setISODay,
    setISOWeek: setISOWeek,
    setISOYear: set_iso_year,
    setMilliseconds: setMilliseconds,
    setMinutes: setMinutes,
    setMonth: set_month,
    setQuarter: setQuarter,
    setSeconds: setSeconds,
    setYear: setYear,
    startOfDay: start_of_day,
    startOfHour: start_of_hour,
    startOfISOWeek: start_of_iso_week,
    startOfISOYear: start_of_iso_year,
    startOfMinute: start_of_minute,
    startOfMonth: startOfMonth,
    startOfQuarter: start_of_quarter,
    startOfSecond: start_of_second,
    startOfToday: startOfToday,
    startOfTomorrow: startOfTomorrow,
    startOfWeek: start_of_week,
    startOfYear: start_of_year,
    startOfYesterday: startOfYesterday,
    subDays: subDays,
    subHours: subHours,
    subISOYears: sub_iso_years,
    subMilliseconds: subMilliseconds,
    subMinutes: subMinutes,
    subMonths: subMonths,
    subQuarters: subQuarters,
    subSeconds: subSeconds,
    subWeeks: subWeeks,
    subYears: subYears
  },
  dateFns_50 = dateFns.format,
  FORMAT_SOAP = "YYYY-MM-DDTHH:mm:ss",
  formatTimestamp = function (e) {
    var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : FORMAT_SOAP;
    return dateFns_50(new Date(1e3 * e), n);
  },
  format$2 = {
    accountNumber: getCustomerFriendlyAccountNumber,
    creditCardNumber: creditCardNumber,
    dateTime: dateTime,
    iban: iban$1,
    money: money,
    number: number,
    convertAmountFromCentsToEuros: convertAmountFromCentsToEuros,
    phone: phone,
    price: price,
    stringToNumber: stringToNumber,
    structuredMessage: structuredMessage,
    timestamp: formatTimestamp
  },
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
  getCurrentResolution = function () {
    return window.innerWidth < SIZES.SIZE_MD ? MOBILE : window.innerWidth >= SIZES.SIZE_MD && window.innerWidth <= SIZES.SIZE_XL ? TABLET : DESKTOP;
  },
  resolutions = {
    MOBILE: MOBILE,
    TABLET: TABLET,
    DESKTOP: DESKTOP,
    getCurrentResolution: getCurrentResolution
  },
  helpers = {
    resolutions: resolutions
  },
  REGEX_SPECIAL_CHARS = /[‘°µ£€!§@#$%^&*()_+=[\]{};:"\\|,.<>/?]/,
  REGEX_DIGIT = /\d/,
  doesNotContainSpecialCharacters = function (e) {
    return !REGEX_SPECIAL_CHARS.test(e);
  },
  doesNotContainDigit = function (e) {
    return !REGEX_DIGIT.test(e);
  },
  common = {
    doesNotContainSpecialCharacters: doesNotContainSpecialCharacters,
    doesNotContainDigit: doesNotContainDigit
  },
  REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  isValid$2 = function (e) {
    return REGEX_EMAIL.test(e);
  },
  email = {
    isValid: isValid$2
  },
  PHONE_NUMBER_CHARS = /^[+\d./ ]+$/,
  isValid$3 = function (e) {
    return PHONE_NUMBER_CHARS.test(e);
  },
  isBelgianCompliant = function (e) {
    var e = e.split(" "),
      e = toArray(e),
      n = e[0],
      e = e.slice(1);
    return "32" === n && "4" === (n = "0" === (n = e.join("").replace(" ", "")).charAt(0) ? n.substr(1) : n).charAt(0) && 9 === n.length;
  },
  lengthIsValid = function (e) {
    return !!e && 5 <= (e = e.split(" ")[1]).length && e.length <= 20;
  },
  phone$1 = {
    isValid: isValid$3,
    isBelgianCompliant: isBelgianCompliant,
    lengthIsValid: lengthIsValid
  },
  isMonthInThePast = function (e) {
    var n = new Date(),
      r = n.getFullYear(),
      n = n.getMonth() + 1,
      e = (n < 10 && (n = "0" + n), e.split("/")),
      e = slicedToArray(e, 2),
      t = e[0],
      e = e[1];
    return !(!e || !t || 2 !== t.length || 4 !== e.length) && parseInt("" + e + t) < parseInt("" + r + n);
  },
  date = {
    isMonthInThePast: isMonthInThePast
  },
  countries$1 = countryList.list,
  validate = function (e) {
    return iban.isValid(e);
  },
  isBelgian = function (e) {
    return "BE" === e.substr(0, 2);
  },
  isLuxembourg = function (e) {
    return "LU" === e.substr(0, 2);
  },
  getIBANPrefix = function (e) {
    return e && e.substring(0, 2).toLowerCase();
  },
  isSepa = function (e) {
    e = getIBANPrefix(e);
    return !e || countries$1[e] && countries$1[e].isSepa;
  },
  isInternational = function (e, n, r, t) {
    e = isSepa(e), t = !t || countries$1[t.toLowerCase()] && countries$1[t.toLowerCase()].isSepa;
    return !((!r || r === n) && e && t);
  },
  iban$2 = {
    validate: validate,
    isBelgian: isBelgian,
    isLuxembourg: isLuxembourg,
    isSepa: isSepa,
    getIBANPrefix: getIBANPrefix,
    isInternational: isInternational
  },
  validate$1 = function (e) {
    return iban.isValidBBAN(1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "BE", e);
  },
  bban = {
    validate: validate$1
  },
  validation = {
    common: common,
    email: email,
    phone: phone$1,
    date: date,
    iban: iban$2,
    bban: bban
  },
  index = {
    config: config,
    format: format$2,
    helpers: helpers,
    validation: validation
  };
exports.default = index, exports.config = config, exports.format = format$2, exports.helpers = helpers, exports.validation = validation;